import { useEffect, useRef, useState } from 'react';
import { Modal, Alert } from '@pmi/dsm-react';
import { Product } from '../../models';
import styles from '../../productcard.module.scss';
import CategoryLabel from '../../../../shared/components/CategoryLabel';
import { reportError } from '../../../../shared/analytics';

interface ConfirmationModalProps {
  product: Product;
  onCancel: () => void;
  onSubmit: () => void;
  reset: () => void;
  isError: boolean;
}

export default function ConfirmationModal({
  product,
  onCancel,
  onSubmit,
  reset,
  isError,
}: ConfirmationModalProps) {
  const { level, totalPDUs } = product;

  const isSubmittingRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const errorMessage = 'There was an error placing the order';
  useEffect(() => {
    if (isError) {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      reportError(errorMessage);
    }
  }, [isError]);

  return (
    <Modal
      show
      headline="Confirm Your Selection"
      customClassName={`d-flex flex-column ${styles.productCard}`}
      variant="input"
      onClose={onCancel}
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancel,
        },
        {
          titleText: 'Confirm and Proceed',
          variant: 'primary',
          onClick: () => {
            if (isSubmittingRef.current) return;
            isSubmittingRef.current = true;
            setIsSubmitting(true);
            onSubmit();
          },
          disabled: isSubmitting,
        },
      ]}
    >
      <div>
        <CategoryLabel type={product.type} className="mb-3 d-inline-flex" />
      </div>
      <h4
        className="d-inline-block mb-2"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: product.name }}
      />
      <div className="label mb-4">
        {level && <span data-testid="course-level">Level: {level}</span>}
        {level && totalPDUs && ' | '}
        {totalPDUs && `PDUs: ${totalPDUs}`}
      </div>
      {isError && (
        <div className="mb-4">
          <Alert
            show
            alertText={errorMessage}
            variant="danger"
            dismissButtonLabel="Dismiss"
            onDismissButtonClick={reset}
          />
        </div>
      )}
    </Modal>
  );
}
